(function() {
  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function getScrollY() {
    return window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || 0;
  }

  function setScrollY(y) {
    // Brute-force: set every possible target. Only the real scroll element takes effect.
    document.documentElement.scrollTop = y;
    document.body.scrollTop = y;
  }

  function smoothScrollTo(targetY, duration) {
    var startY = getScrollY();
    var diff = targetY - startY;
    if (Math.abs(diff) < 2) return;
    var startTime = performance.now();

    function step(t) {
      var elapsed = t - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutQuart(progress);
      setScrollY(startY + diff * eased);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (!hash || hash.length < 2 || hash === '#') return;
    var target;
    try { target = document.querySelector(hash); } catch(err) { return; }
    if (!target) return;
    e.preventDefault();

    var currentY = getScrollY();
    var targetY = target.getBoundingClientRect().top + currentY - 60; // stop 60px above so the wave divider shows
    var dist = Math.abs(targetY - currentY);
    var duration = Math.min(1600, Math.max(900, dist * 0.55));
    smoothScrollTo(targetY, duration);

    if (history.replaceState) history.replaceState(null, '', hash);
  });
})();
